enum RecommendationsFirstLoadVisibility {
  Hidden = 'hidden',
  OrderHistory = 'order-history',
  Predictions = 'predictions',
  PredictionsAndOrderHistory = 'predictions-and-order-history',
}

export { RecommendationsFirstLoadVisibility };
